import FlowWizard from "@shared/components/form/FlowWizard";
import { StepType, ICustomButton } from "@shared/components/form/types";
import { ActivityName, IDrugIntakeRequest } from "app/_modules/core/types";
import { DrugIntakeInfoStep, IDrugIntakeInfoStepContext } from "../steps";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { TNavigationStack } from "app/types";
import { usePost } from "app/queryProvider";
import { useAuth } from "app/auth/hooks/useAuth";
import { Loading } from "@shared/components/loading";
import { IDrugIntakeSubmitForm } from "../../forms";
import { Form } from "@ant-design/react-native";

export enum EActivitySubmitSteps {
  DRUG_INTAKE_INFO = "drugIntakeInfo",
}

export interface IDrugIntakeFlowData {
  drugIntakeInfo: { administered: boolean };
}

const DrugIntakeFlow = ({ activityName, activityId, initialStep = 0, forceReset = false }: { activityName: ActivityName, activityId: string, initialStep?: number, forceReset?: boolean }) => {
  const [drugIntakeForm] = Form.useForm();
  const { meData } = useAuth()
  const navigation = useNavigation<NativeStackNavigationProp<TNavigationStack>>();

  const telemonitoringPathwayId = meData?.current_pathway.id || "";



  const { mutate: createDrugIntake, isPending: isCreatingDrugIntake } = usePost<IDrugIntakeRequest, undefined>({
    options: {
      onSuccess: () => {
        navigation.navigate("ActivitySuccess", { administered: true });
      },
    },
  });

  const drugIntakeInfo: StepType<
    EActivitySubmitSteps.DRUG_INTAKE_INFO,
    { administered: boolean },
    IDrugIntakeInfoStepContext
  > = {
    component: DrugIntakeInfoStep,
    key: EActivitySubmitSteps.DRUG_INTAKE_INFO,
    context: { activityName },
    form: drugIntakeForm,
    initialValues: { administered: false },
    showBackButton: true,
  };

  const steps = [
    drugIntakeInfo,
  ];

  const handleFinish = () => {
    createDrugIntake({
      resource: { name: "pathways", id: telemonitoringPathwayId },
      url: `/activities/${activityId}/drug-intake`,
      data: {
        administered: true,
      },
    });
  };


  if (isCreatingDrugIntake) {
    return <Loading />
  }

  return (
    <FlowWizard<IDrugIntakeFlowData>
      steps={steps}
      onFinish={handleFinish}
      animationType="scale"
      initialStep={forceReset ? 0 : initialStep}
      layout="vertical"
      finishText="buttons.tookMedicine"
      customButtons={{
        customAction: {
          text: "buttons.notTookMedicine",
          onPress: () => {
            navigation.navigate("DrugIntakeSubmit", { activityId });
          },
          variant: "link",
        },
      }}
    />
  );
};


export default DrugIntakeFlow;
